import { createFileRoute } from "@tanstack/react-router";
import { createSEOHead, SEO_DATA } from "@/lib/seo";

export const Route = createFileRoute("/(public)/carte-cadeau")({
  component: RouteComponent,
  head: () => createSEOHead(SEO_DATA.GIFT_CARD),
});

function RouteComponent() {
  return <div>Hello "/(public)/carte-cadeau"!</div>;
}
